<template>
  <div id="applied-prompt" class="container form-container">
    <div class="applied-wrap">
      <div v-if="!batchApplied">
        <h2>{{ cpLang('apply.thankyou') }}</h2>
        <h3 v-html="cpLang('apply.success', {jobtitle: '<b>' + jobTitle + '</b>' })" />
      </div>
      <div v-else>
        <img src="/asset/image/icon/icon-goodluck.svg" alt="" class="goodluck-img">
        <h2>{{ cpLang('apply.goodluck') }}</h2>
        <h3>{{ cpLang('apply.batch_applied') }}</h3>
        <input id="frequency" :v-model="frequency" type="hidden">
      </div>
      <div class="row">
        <i v-show="loading" class="fas fa-circle-notch fa-spin" />
        <div v-show="recommendedJob.length > 0" class="interested">
          <!-- <div class="icon-interest pt-5">
            <img src="/asset/image/icon/ico-interested.png" alt="">
          </div> -->
          <b class="heading py-3">{{ cpLang('apply.interested') }}</b>
        </div>
        <div v-show="recommendedJob.length > 0" class="predict-job-list">
          <div class="btns">
            <label><input v-model="selectAll" class="form-control" type="checkbox" name="all-job"> {{ cpLang('global.select_all') }}</label>
            <div class="float-right">
              <a id="save-all-btn" v-show="hasSelectedJob" @click="save" href="javascript:void(0)"><i class="fa fa-bookmark" /> {{ cpLang('global.save_all') }}</a>&nbsp;&nbsp;
              <a ref="refreshBtn" v-if="hasPages" :class="{'disabled' : disableRefresh}" @click="nextPage" href="javascript:void(0)"><i class="fa fa-redo" /> {{ cpLang('global.refresh') }}</a>
            </div>
          </div>
          <div ref="slider" v-touch:swipe.right="movePrev" v-touch:swipe.left="moveNext" class="slider-wrapper">
            <div ref="sliderdots" class="dots" />
            <a v-if="hasPages" :class="{'disabled' : disableRefresh}" @click="nextPage" href="javascript:void(0)" class="refresh-btn"><i class="fa fa-redo" /> {{ cpLang('global.refresh') }}</a>
            <div v-for="(job, index) in recommendedJob" v-show="currentPage(index)" :key="job.id" class="col col-md-4 col-sm-6 col-xs-12">
              <div>
                <input
                  :value="job.id"
                  @change="checkSelection"
                  class="form-control"
                  type="checkbox"
                  name="job"
                  checked
                >
                <i class="fas fa-circle-notch fa-spin" />
                <i class="fas fa-check-circle" />
                <i class="fas fa-exclamation-circle" />
                <a
                  :key="job.id"
                  :href="`/job/${getFullSlug(job.jobtitletext,job.id)}`"
                  target="_blank"
                >
                  <JobCard
                    :id="job.id"
                    :is-blind="job.blindAd"
                    :priority="job.priority"
                    :logo="job.logoname"
                    :url="job.url"
                    :tag="job.tag"
                    :title="job.jobtitletext"
                    :company="job.displayname"
                    :industry="job.industrydesc"
                    :cluster="job.clusterdesc"
                    :joblevel="job.managerialleveldesc"
                    :employmenttype="job.employmentstatusdesc"
                    :location="job.locationdesc"
                    :activationdate="job.activationdate"
                  />
                </a>
              </div>
            </div>
            <div class="clear-both" />
          </div>
        </div>
      </div>
      <div v-if="predictLoaded" class="text-center">
        <button id="manage-saved-btn" @click="toSavedJob()" class="btn btn-default">
          {{ cpLang('apply.manage_saved') }}
        </button>
        <button v-if="recommendedJob.length > 0" :class="{'disabled':!hasSelectedJob}" @click="batchApply" class="btn btn-primary">
        {{ cpLang('apply.apply_now') }}
        </button>
        <button v-else @click="doSearch" class="btn btn-primary">
        {{ cpLang('apply.continue_search') }}
        </button>
      </div>
      <PopUp :clicked="savedFlag" :callback="closeSaved" class="headless text-center small saved-msg" close enable-click-outside>
        <img src="/asset/image/icon/icon-saved-bookmark.svg" alt="">
        <h5>{{ cpLang('apply.save_for_later') }}</h5>
        <p>{{ cpLang('apply.saved_msg',{'saved':saved}) }}</p>
      </Popup>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'
import PopUp from '~/components/global/Popup'
import JobCard from '~/components/search/JobCard'
import commonHelper from '~/assets/js/commonHelper.js'
Vue.use(Vue2TouchEvents)
export default {
  components: {
    JobCard,
    PopUp
  },
  props: {
    job: {
      type: Object,
      default: null
    },
    application: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      recommendedJob: [],
      loading: true,
      saved: 0,
      savedFlag: false,
      page: 0,
      jobTitle: '',
      frequency: 1,
      slideJobIndex: 0,
      batchApplied: false,
      predictLoaded: false,
      disableRefresh: false,
      hasPages: false,
      selectAll: true,
      hasSelectedJob: true,
      notInterestingJobs: [],
      getJob: null
    }
  },
  watch: {
    selectAll: function() {
      const vm = this
      document.querySelectorAll('input[name="job"]').forEach(function(item) {
        const card = item.parentElement.parentElement
        if (card.style.display !== 'none') {
          item.checked = vm.selectAll
        }
      })
      this.checkSelection()
    },
    notInterestingJobs: function() {
      const uniqueJobs = Array.from(new Set(this.notInterestingJobs))
      this.$cpCookie.set('notinterestingjob', uniqueJobs.join(','), {
        path: '/',
        maxAge: 60 * 7
      })
    }
  },
  created() {
    this.notInterestingJobs = this.$cpCookie.get('notinterestingjob') !== undefined ? this.$cpCookie.get('notinterestingjob').toString().split(',') : []
  },
  mounted() {
    this.loadPredict()
    if (this.job.jobtitletext === undefined) {
      this.loadJob()
    } else {
      this.jobTitle = this.job.jobtitletext
      this.track()
    }
    window.addEventListener('resize', this.resize)
  },
  methods: {
    toSavedJob: function() {
      window.location.href = '/myjob/savedjob'
    },
    loadJob: async function (date) {
      await this.$store.dispatch('jobs/fetchDetail', this.$route.params.id)
      this.getJob = await this.$store.state.jobs.detail
      this.jobTitle = this.getJob.jobtitletext
      this.track()
    },
    track: function () {
      const eventName = 'App-success'
      const mpJobObject = commonHelper.getMixpanelProperty(this.getJob)
      mpJobObject.event = eventName
      mpJobObject.type = 'view'
      this.$gtm.pushEvent({ event: 'jobApplySuccess', queryString: JSON.stringify(mpJobObject) })
    },
    trackApplied: function (id) {
      const mpJobObject = commonHelper.getMixpanelProperty(this.getJob)
      mpJobObject.event = 'App-success'
      mpJobObject.type = 'Batch apply similar jobs'
      mpJobObject['job id'] = id
      this.$gtm.pushEvent({ event: 'jobApplySuccess', queryString: JSON.stringify(mpJobObject) })
    },
    closeSaved: function () {
      this.saved = 0
      this.savedFlag = false
    },
    checkSelection: function () {
      let selected = 0
      document.querySelectorAll('input[name="job"]').forEach(function(item) {
        const card = item.parentElement.parentElement
        if (card.style.display !== 'none') {
          if (item.checked) {
            selected++
          }
        }
      })
      this.hasSelectedJob = selected > 0
    },
    resize: function () {
      if (document.querySelectorAll('.slider-wrapper').length === 0) {
        return false
      }
      // mobile slider
      if (commonHelper.isPortraitMobile()) {
        const jobCount = this.getVisibleJobCount()
        this.$refs.slider.classList.add('mobile')
        if (this.$refs.refreshBtn) {
          this.$refs.refreshBtn.style.display = 'none'
        }
        this.$refs.slider.style.width = jobCount * 100 + '%'
        this.$refs.slider.querySelectorAll('.col').forEach(function(item) {
          item.style.width = 100 / jobCount + '%'
        })
        if (this.$refs.sliderdots.querySelectorAll('i').length === 0) {
          for (let i = 0; i < jobCount; i++) {
            const ele = document.createElement('i')
            if (i === 0) {
              ele.classList.add('active')
            }
            this.$refs.sliderdots.append(ele)
          }
        }
      } else {
        this.$refs.slider.style.width = 'initial'
        this.$refs.slider.style.marginLeft = '0px'
        this.$refs.slider.classList.remove('mobile')
        if (this.$refs.refreshBtn) {
          this.$refs.refreshBtn.style.display = 'inline-block'
        }
        this.$refs.slider.querySelectorAll('.col').forEach(function(item) {
          item.style.width = '100%'
        })
      }
    },
    getVisibleJobCount: function () {
      let count = 0
      document.querySelectorAll('.slider-wrapper .col').forEach(function (item) {
        if (item.style.display !== 'none') {
          count++
        }
      })
      return count
    },
    goToJob: function (index) {
      if (commonHelper.isPortraitMobile()) {
        this.$refs.slider.style.marginLeft = '-' + 100 * index + '%'
        if (this.$refs.sliderdots.querySelectorAll('i.active').length) {
          this.$refs.sliderdots.querySelector('i.active').classList.remove('active')
        }
        if (this.$refs.sliderdots.querySelectorAll('i')[index] !== undefined) {
          this.$refs.sliderdots.querySelectorAll('i')[index].classList.add('active')
        }
      } else {
        this.$refs.slider.style.marginLeft = '0px'
      }
    },
    moveNext: function () {
      if (!commonHelper.isPortraitMobile()) {
        return false
      }
      if (this.slideJobIndex >= this.getVisibleJobCount() || (this.slideJobIndex >= this.getVisibleJobCount() - 1 && (this.disableRefresh || !this.hasPages))) {
        return false
      }
      this.slideJobIndex++
      this.goToJob(this.slideJobIndex)
    },
    movePrev: function () {
      if (!commonHelper.isPortraitMobile() || this.slideJobIndex < 1) {
        return false
      }
      this.slideJobIndex--
      this.goToJob(this.slideJobIndex)
    },
    doSearch: function () {
      window.location.href = 'SearchJobs'
    },
    currentPage: function (index) {
      const sizePerPage = 9
      if (index >= sizePerPage * this.page && index < sizePerPage * (this.page + 1)) {
        return true
      }
      return false
    },
    nextPage: function () {
      if (this.disableRefresh) {
        return
      }
      this.selectAll = true
      this.page += 1
      if (this.page >= Math.ceil(this.recommendedJob.length / 9) - 1) {
        this.disableRefresh = true
      }
      this.slideJobIndex = 0
      this.$refs.sliderdots.innerHTML = ''
      this.$nextTick(() => {
        this.resize()
        this.goToJob(0)
      })
    },
    loadPredict: async function() {
      const result = await this.$axios.get('positions/recommendation?size=36&positionid=' + this.$route.params.id)
      this.recommendedJob = result.data.positions
      this.hasPages = this.recommendedJob.length > 9
      this.loading = false
      this.predictLoaded = true
      this.$nextTick(() => {
        this.resize()
      })
    },
    close: function () {
      this.$emit('close')
    },
    showBatchApplied: function () {
      this.batchApplied = true
      this.predictLoaded = false
      this.loading = true
      this.loadPredict()
    },
    apply: function () {
      const vm = this
      const items = document.querySelectorAll('.applying')
      if (items.length === 0) {
        vm.frequency++
        vm.showBatchApplied()
        return
      }
      const item = items[0]
      const jobid = item.querySelector('input:checked').value
      const formData = new FormData()
      formData.append('positionid', jobid)
      formData.append('email', this.application.email)
      formData.append('firstname', this.application.firstname)
      formData.append('lastname', this.application.lastname)
      // formData.append('workpermit', this.application.permit)
      // formData.append('resumeid', this.application.resumeid)
      // formData.append('coverletter', '')
      formData.append('tag', 'mmplus_batch_multiple')
      this.$axios.post('applications', formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        item.classList.remove('applying')
        item.classList.add('success')
        vm.trackApplied(jobid)
        vm.apply()
      }).catch(function(err) {
        item.classList.remove('applying')
        item.classList.add('error')
        console.error(err)
        vm.apply()
      })
    },
    batchApply: function () {
      if (!this.hasSelectedJob) {
        return false
      }
      const vm = this
      document.querySelectorAll('input[name="job"]').forEach(function(item) {
        const card = item.parentElement.parentElement
        if (card.style.display !== 'none') {
          if (item.checked) {
            item.parentElement.classList.add('applying')
          } else {
            vm.notInterestingJobs.push(item.value)
          }
        }
      })
      this.apply()
    },
    getFullSlug(title, id) {
      const fullSlug = commonHelper.getSlug(title) + '-' + id
      return fullSlug
    },
    save: function () {
      const vm = this
      let savedCount = 0
      vm.saved = 0
      document.querySelectorAll('input[name="job"]').forEach(function(item) {
        const card = item.parentElement.parentElement
        if (item.checked && card.style.display !== 'none') {
          savedCount += 1
          const bookmark = card.querySelector('.bookmark')
          if (bookmark && !bookmark.classList.contains('active')) {
            bookmark.click()
          }
        }
      })
      vm.saved = savedCount
      vm.savedFlag = savedCount > 0
    }
  }
}

</script>

<style lang="scss">
.page-myjob-applicationsubmitted-id{
  .cpj-wrapper{
    overflow-x: hidden;
  }
}
#applied-prompt{
  margin: 0px auto;
  padding: 60px 30px;
  min-height: 60vh;
  .applied-wrap{
    background: #fff;
    padding: 80px 30px;
    width: fit-content;
    margin: auto;
    border-radius: 20px;
  }
  .saved-msg{
    h5{
      font-size: 16px;
      font-weight: bold;
      color:#707070;
    }
  }
  h2{
    font-size: 20px;
    font-weight: bold;
    color:#707070;
    text-align: center;
    margin-bottom: 22px;
  }
  .goodluck-img{
    display: block;
    margin: 20px auto;
    max-width: 90%;
  }
  h3{
    font-size: 14px;
    color:#707070;
    font-weight: normal;
    text-align: center;
    line-height: 1.5;
    b{
      font-size: 16px;
      font-weight: bold;
      color:#0081BE;
      display: block;
    }
  }
  .fa-spin{
      position: absolute;
      left: 50%;
      top: 50%;
      font-size: 40px;
      margin: 30px 0px 0px -20px;
    }
  .text-center{
    a{
      color: #0EA5BF;
      font-size: 14px;
      margin:0px 20px;
    }
    .btn{
      padding-left: 40px;
      padding-right: 40px;
    }
  }
  .predict-job-list{
    min-height: 300px;
    position: relative;
    margin: 10px auto;
    max-width: 950px;
    // background: #D5DEE6;
    border-radius: 5px;
    padding: 20px;
    input[type='checkbox']::before{
      border-color: #FAFAFA;
    }
    .btns{
      label{
        font-size: 14px;
        padding-left: 5px;
        input{
          vertical-align: middle;
          display: inline-block;
        }
      }
      a{
        color:#0EA5BF;
        font-size: 14px;
        &.disabled{
          color: #999999;
          cursor:not-allowed;
        }
      }
    }
    .slider-wrapper{
      transition: margin 0.3s ease-in;
      .refresh-btn{
        display: none;
        position: absolute;
        font-size: 18px;
        right: 0px;
        width: 100%;
        text-align: center;
        margin-top: 50px;
        color: #0EA5BF;
        i{
          font-size: 38px;
          display: block;
        }
      }
      .dots{
        display: none;
        position: absolute;
        bottom: 10px;
        width: 90%;
        text-align: center;
        left: 50%;
        margin-left: -45%;
        i{
          background-color: #ffffff;
          height: 10px;
          width: 10px;
          border-radius: 50%;
          display: inline-block;
          margin: 4px;
          &.active{
            background-color: #0EA5BF;
          }
        }
      }
      &.mobile{
        .col{
          .card{
            max-width: 100%;
            transform: scale(1.02);
          }
          input{
            bottom: -10px;
          }
        }
        .dots{
          display: block;
        }
        .refresh-btn{
          display: block;
          &.disabled{
            display: none;
          }
        }
      }
    }
    .col{
      padding: 5px;
      height: auto;
      margin-bottom: 15px;
      input{
        position: absolute;
        z-index: 10;
        bottom: 0px;
        left: 50%;
        margin-left: -8px;
      }
      .fas{
        display: none;
        font-size: 30px;
        position: absolute;
        left: 50%;
        top:50%;
        margin: -20px 0px 0px -15px;
        z-index: 1;
      }
    }
    .applying{
      .cp-job-card{
        opacity: 0.7;
      }
      .fa-spin{
        display: block;
      }
    }
    .success{
      .fa-check-circle{
        display: block;
        color:#0EA5BF;
      }
    }
    .error{
      .fa-exclamation-circle{
        display: block;
        color:#dc3545;
      }
    }
  }
  .cp-job-card{
    min-width: auto;
    max-height: 150px;
    margin-bottom: 10px;
    border: 1px solid #ececec;
    padding: 15px;
    box-shadow: 0 3px 10px #00000029;
    .cp-job-title {
      font-size: 14px;
      line-height: 16px;
      margin-top: 35px;
    }
    .cp-job-company{
      font-size: 12px;
      line-height: 14px;
      margin: 0px;
    }
    &:hover{
      box-shadow: 0 3px 10px #00000080;
    }
  }
  .cp-job-info-block{
    display: none;
  }
  .interested {
    text-align: center;
    line-height: 21px;
    font-size: 14px;
    margin: 0 38px;
    text-align: center;

    .icon-interest>img {
      height: 60px;
      width: auto;
      margin: 10px 0;
    }

    b.heading {
      font-size: 16px;
    }
  }
}
#manage-saved-btn{
  font-size: 14px;
}
</style>
